import axios from 'axios'

const state = {
  isLoading: false,
  suggestions: [],
  error: null
}

const mutations = {
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading
  },
  SET_SUGGESTIONS(state, suggestions) {
    state.suggestions = suggestions
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  CLEAR_SUGGESTIONS(state) {
    state.suggestions = []
  }
}

const actions = {
  async fetchCompanyData({ commit }, { query, type = 'name' }) {
    try {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      
      const token = '6e382657335eedb998c2c0139443ecda4fa66470'
      const response = await axios.post(
        'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party',
        { query, count: 5 },
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Token ${token}`
          }
        }
      )

      commit('SET_SUGGESTIONS', response.data.suggestions || [])
      return response.data.suggestions
    } catch (error) {
      commit('SET_ERROR', error)
      console.error('Ошибка DaData:', error)
      return []
    } finally {
      commit('SET_LOADING', false)
    }
  },

  clearSuggestions({ commit }) {
    commit('CLEAR_SUGGESTIONS')
  }
}

const getters = {
  companySuggestions: state => state.suggestions,
  isLoading: state => state.isLoading,
  error: state => state.error
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}